import { IObservationAction } from "../actions/observationActions";
import IObservation, { INewObservation, makeObservationSkeleton, makeProcessFormSkeleton } from "../../interfaces/IObservation";
import { TSubmittable, createSubmitting, createSubmitErrored, createSubmitted, createUnsubmitted, TLoadable, createUnloaded, createLoading, createLoaded, createLoadErrored, isLoaded } from "../../../../sg-core";

export const defaultObservationState: IObservationState = {
    observation: createUnloaded(),
};

export interface IObservationState {
    observation: TLoadable<IObservation>;
    processForm?: TSubmittable<{ [key: string]: any }>;
    newObservation?: TSubmittable<INewObservation>;
    delegationStatus?: TSubmittable<any>;
}


export default function ObservationReducer(state = defaultObservationState, action: IObservationAction) {
    switch (action.type) {

        case "REQUEST_FETCH_OBSERVATION": {
            return {
                ...state,
                observation: createLoading(),
            };
        }
        case "SUCCESS_FETCH_OBSERVATION": {
            return {
                ...state,
                observation: createLoaded(action.payload.observation)
            };
        }
        case "FAILURE_FETCH_OBSERVATION": {
            return {
                ...state,
                observation: createLoadErrored(action.payload.error)
            };
        }

        case "REQUEST_FETCH_DELEGATE_OBSERVATION": {
            return {
                ...state,
                delegationStatus: createSubmitting(false),
            };
        }
        case "SUCCESS_FETCH_DELEGATE_OBSERVATION": {
            return {
                ...state,
                delegationStatus: createSubmitted(true),
                // observation: action.payload.
            };
        }
        case "FAILURE_FETCH_DELEGATE_OBSERVATION": {
            return {
                ...state,
                delegationStatus: createSubmitErrored(false, action.payload.error)
            };
        }
        case "CLEAR_OBSERVATION_DELEGATION": {
            return {
                ...state,
                delegationStatus: undefined
            };
        }



        // HANDLE PROCESS PHASE FORM
        case "INITIALIZE_OBSERVATION_PROCESS_FORM": {
            if (isLoaded(state.observation)) {
                const { observation, userId } = action.payload
                const processForm = makeProcessFormSkeleton(
                    observation,
                    userId,
                    state.observation.data.is_public,
                    action.payload.processingMarkingPublicity,
                    undefined,
                    action.payload.classificationText
                )
                return {
                    ...state,
                    delegationStatus: createUnsubmitted(false),
                    processForm: createUnsubmitted(processForm)
                };
            }
            return state
        }
        case "OBSERVATION_PROCESS_FORM_DATA_UPDATE": {
            const newData = {
                ...(state.processForm!.data || {}),
                formData: action.payload.formData
            };
            return {
                ...state,
                processForm: createUnsubmitted(newData)
            };
        }
        case "CLEAR_OBSERVATION_PROCESS_FORM": {
            return {
                ...state,
                processForm: undefined
            };
        }
        case "REQUEST_FETCH_SAVE_OBSERVATION_PROCESS_FORM": {
            if (state.processForm) {
                return {
                    ...state,
                    processForm: createSubmitting(state.processForm.data),
                };
            }
            return state
        }
        case "SUCCESS_FETCH_SAVE_OBSERVATION_PROCESS_FORM": {
            if (state.processForm) {
                return {
                    ...state,
                    processForm: createSubmitted(state.processForm.data),
                    observation: createLoaded(action.payload.observation)
                };
            }
            return state
        }
        case "FAILURE_FETCH_SAVE_OBSERVATION_PROCESS_FORM": {
            if (state.processForm) {
                return {
                    ...state,
                    processForm: createSubmitErrored(state.processForm.data, action.payload.error),
                };
            }
            return state
        }



        // CREATE OBSERVATION
        case "INITIALIZE_NEW_OBSERVATION_FORM": {
            const formType = action.payload.formType
            const data = makeObservationSkeleton(formType, action.payload.user, action.payload.isPublic)
            return {
                ...state,
                newObservation: createUnsubmitted(data)
            };
        }
        case "NEW_OBSERVATION_FORM_DATA_UPDATE": {
            const newData = {
                ...(state.newObservation!.data || {}),
                formData: action.payload.formData
            };
            return {
                ...state,
                newObservation: createUnsubmitted(newData)
            };
        }
        case "REQUEST_FETCH_CREATE_OBSERVATION": {
            return {
                ...state,
                newObservation: createSubmitting(state.newObservation!.data),
            };
        }
        case "SUCCESS_FETCH_CREATE_OBSERVATION": {
            return {
                ...state,
                newObservation: createSubmitted(action.payload.observation),
            };
        }
        case "FAILURE_FETCH_CREATE_OBSERVATION": {
            return {
                ...state,
                newObservation: createSubmitErrored(state.newObservation!.data, action.payload.error),

            };
        }
        case "CLEAR_OBSERVATION_CREATE_OBSERVATION": {
            return {
                ...state,
                newObservation: undefined,
            };
        }
        default: {
            return state;
        }
    }
}
